
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class Calendar extends Vue {

    get title() {
        return this.cardItem ? this.cardItem.value : "";
    }

    get concernedEvents() {
        if (!this.cardItem) {
            return this.events;
        }
        switch (this.cardItem.type) {
            case "key":
                return this.events.filter((event) => event.key.id === this.cardItem.id);
            case "user":
                return this.events.filter((event) => event.user.id === this.cardItem.id);
            default:
                return this.events;
        }
    }

    get lang(): string {
        return this.$root.$i18n.locale;
    }
    @Prop()
    public type: string;

    @Prop()
    public focus: string;

    @Prop({default: null})
    public cardItem: any;

    @Prop({default: []})
    public events: any[];

    public selectedEvent: object = {};
    public selectedElement: object = null;
    public selectedOpen: boolean = false;
    public colors: string[] = ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"];
    public currentFocus: string = "";
    public loadedRange: boolean = false;

    public $refs!: {
        calendar: HTMLFormElement,
    };

    @Getter private isMobile: boolean;

    @Watch("focus")
    public handlerFocus() {
        this.currentFocus = this.focus;
    }

    private mounted() {
        this.currentFocus = this.focus;
        this.$refs.calendar.checkChange();
        this.updateRange({
            start: this.$refs.calendar.lastStart,
            end: this.$refs.calendar.lastEnd,
        });
    }

    private showEvent({ nativeEvent, event }) {
        this.$emit("showEvent", event);
        nativeEvent.stopPropagation();
    }

    private updateRange({ start, end }) {
        if (!this.loadedRange) {
            return this.loadedRange = true;
        }
        this.$emit("updateRange", {
            start,
            end,
        });
    }

    // Called using $refs in parent component
    private prev() {
        this.$refs.calendar.prev();
        this.$emit("update-focus", this.currentFocus);
    }

    // Called using $refs in parent component
    private next() {
        this.$refs.calendar.next();
        this.$emit("update-focus", this.currentFocus);
    }

    private viewDay({ date }) {
        this.$emit("update-focus", date);
        this.$emit("update-type", "day");
    }

    private getEventColor(event) {
        return event.color;
    }
    private openAddReservationModal(date) {
        this.$emit("addBooking", {date});
    }
}
